import moment from "moment";
import BookingsScreen from "../BookingScreen/BookingsScreen";
import {
  useCalenderBookingsQuery,
  useDeskBookingsQuery,
} from "../BookingScreen/queries/useBookingsQueries";
import CalendarScreen from "../CalenderScreen/CalendarScreen";
import {
  useCalenderTodayQuery,
  useCalenderTomorrowQuery,
} from "../CalenderScreen/queries/useCalenderQueries";
import DiashowScreen from "../DiashowScreen/DiashowScreen";
import { useDiashowQuery } from "../DiashowScreen/queries/useDiashowQuery";
import ScreenTransitioner from "../ScreenTransitioner/ScreenTransitioner";
import { useVacationQuery } from "../VacationScreen/queries/useVacationQueries";
import VacationsScreen from "../VacationScreen/VacationsScreen";
import SchalkeAppScreen from "../SchalkeAppScreen/SchalkeAppScreen";
import { useSchalkeAppStatsQuery } from "../SchalkeAppScreen/queries/useSchalkeAppStatsQueries";
import MotivationalQuoteScreen from "../MotivationalQuoteScreen/MotivationalQuoteScreen";
import KicktippBonusScreen from "../KicktippScreen/KicktippBonusScreen";
import KicktippGameDayScreen from "../KicktippScreen/KicktippGameDayScreen";
import KicktippGameDayTableScreen from "../KicktippScreen/KicktippGameDayTableScreen";
import KicktippTotalScreen from "../KicktippScreen/KicktippTotalScreen";
import KicktippBuliTableScreen from "../KicktippScreen/KicktippBuliTableScreen";
import KicktippInviteScreen from "../KicktippScreen/KicktippInviteScreen";
import WorldCupGroupsScreen from "../WorldCupScreen/WorldCupGroupsScreen";
import WorldCupGamesScreen from "../WorldCupScreen/WorldCupGamesScreen";
import WorldCupKnockoutScreen from "../WorldCupScreen/WorldCupKnockoutScreen";

const christmasTime = (): boolean => {
  const compareDate = moment();
  const startDate = moment("01/12", "DD/MM");
  const endDate = moment("27/12", "DD/MM");
  return compareDate.isBetween(startDate, endDate);
};

const DataWrapperScreen: React.FC = () => {
  // const kicktippData = useKicktippQuery();
  const bookingsDeskData = useDeskBookingsQuery();
  const bookingsCalendarData = useCalenderBookingsQuery();
  const vacationsData = useVacationQuery();
  const calendarTodayData = useCalenderTodayQuery();
  const calendarTommorowData = useCalenderTomorrowQuery();
  // const diashowData = useDiashowQuery();
  const isChristmasTime = christmasTime();
  // const schalkeAppStatsData = useSchalkeAppStatsQuery();

  if (
    // kicktippData.isLoading ||
    bookingsDeskData.isLoading ||
    bookingsCalendarData.isLoading ||
    vacationsData.isLoading ||
    calendarTodayData.isLoading ||
    calendarTommorowData.isLoading
  )
    return <div>Loading...</div>;

  if (
    // !kicktippData.data &&
    !bookingsDeskData.data &&
    !bookingsCalendarData.data &&
    !vacationsData.data &&
    !calendarTodayData.data &&
    !calendarTommorowData.data
  )
    return <div>Loading...</div>;

  return (
    <ScreenTransitioner>
      <MotivationalQuoteScreen
        duration={25000}
        christmasTime={isChristmasTime}
      />
      <CalendarScreen duration={8000} christmasTime={isChristmasTime} />
      <BookingsScreen
        duration={25000}
        christmasTime={isChristmasTime}
        beerOclock={false}
      />
      {/*<SchalkeAppScreen duration={20000} christmasTime={isChristmasTime} />*/}
      <VacationsScreen duration={8000} christmasTime={isChristmasTime} />
      <KicktippGameDayScreen duration={20000} christmasTime={isChristmasTime} />
      <KicktippGameDayTableScreen
        duration={15000}
        christmasTime={isChristmasTime}
      />
      <KicktippBonusScreen duration={10000} christmasTime={isChristmasTime} />
      <KicktippBuliTableScreen
        duration={15000}
        christmasTime={isChristmasTime}
      />
      {/*<KicktippTotalScreen duration={15000} christmasTime={isChristmasTime} />*/}
      {/*<WorldCupGroupsScreen duration={20000} christmasTime={isChristmasTime} />*/}
      {/*<WorldCupKnockoutScreen
        duration={20000}
        christmasTime={isChristmasTime}
      />
      <WorldCupGamesScreen duration={10000} christmasTime={isChristmasTime} />*/}
      {/*<KicktippInviteScreen duration={1000} christmasTime={isChristmasTime} />*/}
      <DiashowScreen duration={40000} christmasTime={isChristmasTime} />
    </ScreenTransitioner>
  );
};

export default DataWrapperScreen;
